import { Link } from "react-router-dom";
import { usePrivilege } from "../../../../../components/priviledge/PriviledgeProvider";
import { menuRoutes } from "../../../../../router/menu";
import { Contract } from "../../../../../type/entities/contract-type";
import cn from "../../../../../utils/classNames";
import { gender } from "../../../../students/StudentForm";
import {
    formatInfoDate,
    formatInfoValue,
    InfoBooleanField,
    InfoCard,
    InfoField,
    InfoGroup,
    InfoTextField,
} from "./components/InfoDisplay";

interface StudentContractFormInfoProps {
    data: Contract;
}

const StudentContractFormInfo = ({ data }: StudentContractFormInfoProps) => {
    const { userCan } = usePrivilege();
    const canViewStudent = userCan("get_students", "students");

    const genderLabel = gender?.find((item: any) => item.value === data?.studentGender)?.label;

    return (
        <InfoCard
            title="Datos de Empleado"
            subtitle="Empleado asociado al contrato."
            action={canViewStudent ? (
                <Link
                    className={cn("text-primary hover:text-blue-700 font-semibold")}
                    to={`/students/${data?.student?.id}/profile${menuRoutes.students.profile.info}`}
                    state={{
                        fromContract: true,
                        returnToContractPath: `${menuRoutes.contracts.path}/${data?.id}/profile${menuRoutes.contracts.profile.info}`,
                    }}
                >
                    Ver Empleado
                </Link>
            ) : undefined}
        >
            <InfoGroup title="Información General" description="Datos identificativos y de contacto del empleado.">
                <InfoField label="NIF/NIE" value={formatInfoValue(data?.studentNif)} className="md:col-span-4" />
                <InfoField label="Nombre" value={formatInfoValue(data?.studentName)} className="md:col-span-4" />
                <InfoField label="Primer Apellido" value={formatInfoValue(data?.studentFirstName)} className="md:col-span-4" />
                <InfoField label="Segundo Apellido" value={formatInfoValue(data?.studentLastName)} className="md:col-span-4" />
                <InfoField label="Número de Seguridad Social" value={formatInfoValue(data?.studentSocialSecurityNumber)} className="md:col-span-4" />
                <InfoField label="Email" value={formatInfoValue(data?.studentEmail)} className="md:col-span-4" />
                <InfoField label="Teléfono" value={formatInfoValue(data?.studentTelephone)} className="md:col-span-4" />
                <InfoField label="Teléfono adicional" value={formatInfoValue(data?.studentTelephoneSecondary)} className="md:col-span-4" />
                <InfoField label="Teléfono móvil" value={formatInfoValue(data?.studentMobile)} className="md:col-span-4" />
                <InfoField label="Género" value={formatInfoValue(genderLabel)} className="md:col-span-3" />
                <InfoField label="Fecha de Nacimiento" value={formatInfoDate(data?.studentBirthDate)} className="md:col-span-3" />
                <InfoTextField label="Observaciones" value={data?.studentComment} className="md:col-span-6" />
            </InfoGroup>

            <InfoGroup title="Datos adicionales" description="Información adicional del empleado.">
                <InfoField label="Estudios" value={formatInfoValue(data?.studentStudy?.name)} className="md:col-span-4" />
                <InfoField label="Categoría Profesional" value={formatInfoValue(data?.studentProfessionalCategory?.name)} className="md:col-span-4" />
                <InfoField label="Grupo de Cotización" value={formatInfoValue(data?.studentQuotationGroup?.name)} className="md:col-span-4" />
                <InfoField label="Área Funcional" value={formatInfoValue(data?.studentFunctionalArea)} className="md:col-span-4" />
                <InfoField label="Dirección de envío alternativa" value={formatInfoValue(data?.studentAlternativeShippingAddress)} className="md:col-span-4" />
                <InfoField label="Horario de contacto" value={formatInfoValue(data?.studentContactSchedule)} className="md:col-span-4" />
                <InfoBooleanField label="¿Tiene alguna discapacidad?" value={data?.studentDisability} className="md:col-span-4" />
                <InfoBooleanField label="Víctima de violencia de género" value={data?.studentGenderViolenceVictim} className="md:col-span-4" />
                <InfoBooleanField label="Víctima de terrorismo" value={data?.studentTerrorismVictim} className="md:col-span-4" />
            </InfoGroup>
        </InfoCard>
    );
};

export default StudentContractFormInfo;
